<template>
    <div>
        <div class="mb15">
            <el-button type="primary" @click="create">{{ $t('create_stream') }}</el-button>
        </div>

        <StreamItem ref="stream"  />
    </div>
</template>

<script>
    import StreamItem from '../components/StreamItem'

    export default {
        name: "Stream",
        components: {
            StreamItem
        },
        created () {
            this.$parent.title='streams';
        },
        methods: {
            create () {
                this.$refs.stream.create(null);
            }
        },
    }
</script>

<style scoped>

</style>